<template>
  <section class="mt-3">
    <b-overlay :show="loading" rounded="sm">

      <h5 class="mt-3">{{ $t("SIGNATURE") }}</h5>
      <div class="mt-1">    

        <b-form-textarea
          v-model="signature"
          rows="5"
          max-rows="6"
        ></b-form-textarea>
      </div>

      <hr class="p-0 m-0 mt-4 mb-2" />
      

      <b-button variant="primary" class="btn-fill" @click="saveSubmit">{{
        $t("SAVE")
      }}</b-button>
    </b-overlay>
  </section>
</template>
<script>
export default {
  props: ["userinfo"],
  data() {
    return {
      loading: false,
      signature: this.userinfo.signature
    };
  },
  methods: {
    saveSubmit: function() {
      let self = this;
      this.loading = true;
      this.$http
        .post(this.user.hostname + "/user/edit/signature", {
          account_id: this.userinfo.id,
          signature: this.signature
        })
        .then(function() {
          self.$noty.info(self.$t("SAVED"));
          self.loading = false;
        })
        .catch(function() {
          self.loading = false;
        });
    }
  },
  computed: {
  },
  mounted: function() {},
};
</script>
<style></style>
